import { createContext } from 'react';

export const TranslationClientContext = createContext<{ translations: Record<string, any> | null; fallback: Record<string, any> | null } | null>({
   translations: null,
   fallback: null
});
